import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { PartnersMarquee } from "@/components/PartnersMarquee";
import { Biography } from "@/components/Biography";
import { Ventures } from "@/components/Ventures";
import { DigiDoc } from "@/components/DigiDoc";
import { Expertise } from "@/components/Expertise";
import { Projects } from "@/components/Projects";
import { Partnerships } from "@/components/Partnerships";
import { Speaking } from "@/components/Speaking";
import { Testimonials } from "@/components/Testimonials";
import { Awards } from "@/components/Awards";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

const Home = () => (
  <main data-testid="home-main">
    <Header />
    <Hero />
    <PartnersMarquee />
    <Biography />
    <Ventures />
    <DigiDoc />
    <Expertise />
    <Projects />
    <Partnerships />
    <Speaking />
    <Awards />
    <Testimonials />
    <Contact />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0A192F",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
